export default __webpack_public_path__ + "static/media/project2-DJI_0444.dc6ea7bb.jpg";